import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-screening-parties-homepage',
  templateUrl: './screening-parties-homepage.component.html',
  styleUrls: ['./screening-parties-homepage.component.css']
})
export class ScreeningPartiesHomepageComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }
  gotoJoin(): void {
    this.router.navigate([`/cinejoy/screening-parties/join`]);
  }

  gotoHost(): void {
    this.router.navigate([`/cinejoy/screening-parties/host`]);
  }
}
